import { useState } from 'react'
import styles from './InviteNudge.module.css'

type InviteNudgeProps = {
  joinCode: string
}

export function InviteNudge({ joinCode }: InviteNudgeProps) {
  const [copied, setCopied] = useState(false)

  function handleCopy() {
    void navigator.clipboard.writeText(joinCode).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <div className={styles.card}>
      <span className={styles.icon} aria-hidden="true">📣</span>
      <div className={styles.text}>
        <div className={styles.title}>Convide amigos para a liga</div>
        <div className={styles.sub}>Uma liga fica muito melhor com mais gente. Compartilhe o código.</div>
      </div>
      <div className={styles.codeRow}>
        <span className={styles.code}>{joinCode}</span>
        <button className={styles.copy} onClick={handleCopy}>
          {copied ? 'Copiado!' : 'Copiar'}
        </button>
      </div>
    </div>
  )
}
